/**
 * Central configuration for all Google AdSense units on the site.
 *
 * Keep every publisher/slot id here so wiring up the AdSense dashboard is a single-file edit.
 * After your AdSense account is approved, create the ad units in the dashboard and replace the
 * placeholder slot ids below with the real ones.
 */

// Your AdSense publisher ID.
export const ADSENSE_CLIENT = 'ca-pub-5312633964377592';

// Ad unit slot ids (create these as "Display" units in the AdSense dashboard).
// Until replaced with real ids, real ads won't fill (a dev placeholder is shown instead - see below).
export const AD_SLOTS = {
    sideRailLeft: '0000000000',   // TODO: replace with the left vertical rail slot id
    sideRailRight: '0000000000',  // TODO: replace with the right vertical rail slot id
    banner: '0000000000',         // TODO: replace with the top responsive banner slot id
    inContent: '0000000000',      // TODO: replace with the in-content responsive slot id
};

/**
 * When true, <GoogleAd> renders a labeled grey placeholder box instead of calling AdSense.
 * This lets you see exactly where/what size ads will appear during development, without a live
 * AdSense account. Defaults to ON in development builds and OFF in production.
 *
 * Override explicitly at build time with REACT_APP_SHOW_AD_PLACEHOLDERS = "true" | "false".
 */
export const SHOW_AD_PLACEHOLDERS = (() => {
    const override = process.env.REACT_APP_SHOW_AD_PLACEHOLDERS;
    if (override === 'true') return true;
    if (override === 'false') return false;
    return process.env.NODE_ENV !== 'production';
})();
